import type { FaireProductEntity } from "../../entity_types/product";

export const p_91ld4gsp: FaireProductEntity = {
  token: "p_91ld4gsp",
  type: "product",
  name: "Freshwater Keshi Pearl Hoops",
  brandName: "Toasted Jewelry",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/67cebb6de25333be0d735d9d2e9f143cae44447aee3665a9c46b1780571a683a/1546478016.jpg",
  priceDollars: 57.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/6c26a34c416980a8803a84d613053915f7c32904003f9fd3fe95be15c4aa9715.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
